import { render } from "./product-popup.vue?vue&type=template&id=95738536&scoped=true"
import script from "./product-popup.vue?vue&type=script&lang=js"
export * from "./product-popup.vue?vue&type=script&lang=js"

import "./product-popup.vue?vue&type=style&index=0&id=95738536&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95738536"]])

export default __exports__